import React, {
  useEffect,
  useCallback,
  useRef,
  Fragment,
} from 'react'
import moment from 'moment'
import { INDEX_PAGE } from './routes'
import AuthService from 'src/services/auth-service'
import { LAST_ACTIVITY, TIME_INACTIVE_MAX } from './constants'

const SessionTimeout = () => {
  const events = useRef(['click', 'load', 'scroll'])

  const authService = new AuthService()

  let timeStamp
  let warningInactiveInterval = useRef()
  let startTimerInterval = useRef()

  // start inactive check
  let timeChecker = () => {
    startTimerInterval.current = setTimeout(() => {
      let storedTimeStamp = sessionStorage.getItem(LAST_ACTIVITY)
      warningInactive(storedTimeStamp)
    }, 60000)
  }

  // function to clear cache and logout client
  const logout = () => {
    clearInterval(warningInactiveInterval.current)
    sessionStorage.removeItem(LAST_ACTIVITY)
    authService.logout()
    window.removeEventListener(events, resetTimer)
    if (window.location.replace) {
      window.location.replace(INDEX_PAGE)
    } else {
      window.location.href = INDEX_PAGE
    }
  }

  // warning timer
  let warningInactive = (timeString) => {
    clearTimeout(startTimerInterval.current)

    warningInactiveInterval.current = setInterval(() => {
      const maxTime = TIME_INACTIVE_MAX

      const diff = moment.duration(moment().diff(moment(new Date(timeString))))
      const minPast = diff.minutes()

      if (minPast === maxTime) {
        logout()
      }
    }, 1000)
  }

  // reset interval timer
  let resetTimer = useCallback(() => {
    clearTimeout(startTimerInterval.current)
    clearInterval(warningInactiveInterval.current)

    timeStamp = moment()
    sessionStorage.setItem(LAST_ACTIVITY, timeStamp)

    timeChecker()
  }, [])

  useEffect(() => {
    events.current.forEach((event) => {
      window.addEventListener(event, resetTimer)
    })

    timeChecker()

    return () => {
      clearTimeout(startTimerInterval.current)
      clearInterval(warningInactiveInterval.current)
      events.current.forEach((event) => {
        window.removeEventListener(event, resetTimer)
      })
    }
  }, [resetTimer, timeChecker])

  return <Fragment />
}

export default SessionTimeout
